import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import TableChart from '@mui/icons-material/TableChart';
import SettingsSystemDaydreamIcon from '@mui/icons-material/SettingsSystemDaydream';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import { EditDocument, ElectricCar, LocationCity, ScienceOutlined } from '@mui/icons-material';

import EmptyLayout from 'src/layouts/EmptyLayout';
import AppLayout from 'src/layouts/MainLayout';

import HomePage from 'src/features/home/HomePage';

import NotFoundPage from 'src/features/404/NotFoundPage';

import { PvSolVmPage } from 'src/features/pv-sol-vm/PvSolVmPage';

import PVAnalysisListPage from 'src/features/pv-analysis/PvAnalysisListPage';
import PvAnalysisCreateEditPage from 'src/features/pv-analysis/PvAnalysisCreateEditPage';
import NewBuilding from 'src/features/pv-analysis/NewBuilding';
import OnsiteVisitListPage from 'src/features/onsite-visit/OnsiteVisitListPage';
import CoordinatesToMap from 'src/features/dev-tools/CoordinatesToMap';
import OnsiteVisitSubmitPage from 'src/features/onsite-visit/OnsiteVisitSubmitPage';
import DocumentTemplateListPage from './features/document-generation/DocumentTemplateListPage';
import DocumentTemplateCreateEditPage from './features/document-generation/DocumentTemplateCreateEditPage';
import DocumentGenerationNewDocumentPage from './features/document-generation/new-document/DocumentGenerationNewDocumentPage';
import DataCatalogPage from './features/document-generation/data-catalog/DataCatalogPage';
import OffersListPage from './features/offer-processing/OffersListPage';
import OfferEvaluationPage from './features/offer-evaluation/OfferEvaluationPage';
import OfferEvaluationsListPage from './features/offer-evaluation/OfferEvaluationsListPage';
import RealEstateAssetManagementPage from './features/real-estate-asset-management/RealEstateAssetManagementPage';
import SteckbriefVariantFormPage from './features/real-estate-asset-management/SteckbriefVariantFormPage';
import ReaCollectionViewPage from './features/real-estate-asset-management/ReaCollectionViewPage';
import ProductRequirementsConfigPage from './features/product-requirements-config/ProductRequirementsConfigPage';

export enum PAGETYPE {
    MAIN,
    FOOTER,
}

export const routesConfig = [
    {
        element: <AppLayout />,
        children: [
            {
                id: 'homepage',
                path: '/',
                handle: {
                    title: 'Home',
                    type: PAGETYPE.MAIN,
                    icon: <HomeRoundedIcon />,
                },
                children: [
                    {
                        id: 'homepage_index',
                        index: true,
                        element: <HomePage />,
                    },

                    {
                        id: 'dev',
                        path: '/dev',
                        handle: {
                            title: 'Development',
                            type: PAGETYPE.MAIN,
                            icon: <ScienceOutlined />,
                        },
                        children: [],
                    },
                    {
                        id: 'pv-analysis',
                        path: '/pv-analysis',
                        handle: {
                            title: 'Potential Analysis',
                            type: PAGETYPE.MAIN,
                            icon: <SolarPowerIcon />,
                        },
                        children: [
                            {
                                id: 'pv-analysis-list',
                                path: '/pv-analysis',
                                element: <PVAnalysisListPage />,
                                handle: {
                                    title: 'Potential Analyses',
                                },
                            },
                            {
                                id: 'pv-analysis-create',
                                path: '/pv-analysis/create',
                                element: <PvAnalysisCreateEditPage />,
                                handle: {
                                    title: 'Create New Potential Analysis',
                                },
                            },
                            {
                                id: 'pv-analysis-details',
                                path: '/pv-analysis/pv-analysis-variation/:id/details',
                                element: <PvAnalysisCreateEditPage />,
                            },
                            {
                                id: 'pv-analysis-import-building',
                                path: '/pv-analysis/import-building',
                                element: <NewBuilding />,
                            },
                        ],
                    },
                    {
                        id: 'onsite',
                        path: '/onsite',
                        handle: {
                            title: 'Onsite',
                            type: PAGETYPE.MAIN,
                            icon: <ElectricCar />,
                        },
                        children: [
                            {
                                id: 'onsite-visit-global',
                                path: '/onsite/onsite-visit/global',
                                element: <OnsiteVisitListPage />,
                                handle: {
                                    title: 'Onsite Visits',
                                },
                            },
                            {
                                id: 'onsite-visit-submit',
                                path: '/onsite/onsite-visit/:id/submit',
                                element: <OnsiteVisitSubmitPage />,
                            },
                        ],
                    },
                    {
                        id: 'document-generation',
                        path: '/document-generation',
                        handle: {
                            title: 'Document Generation',
                            type: PAGETYPE.MAIN,
                            icon: <EditDocument />,
                        },
                        children: [
                            {
                                id: 'data-catalog',
                                path: '/document-generation/data-catalog',
                                element: <DataCatalogPage />,
                                handle: {
                                    title: 'Data Catalog',
                                },
                            },
                            {
                                id: 'templates',
                                path: '/document-generation/templates',
                                element: <DocumentTemplateListPage />,
                                handle: {
                                    title: 'Templates',
                                },
                            },
                            {
                                id: 'create-template',
                                path: '/document-generation/templates/create',
                                element: <DocumentTemplateCreateEditPage />,
                            },
                            {
                                id: 'edit-template',
                                path: '/document-generation/templates/:id/edit',
                                element: <DocumentTemplateCreateEditPage />,
                            },
                            {
                                id: 'generate-document',
                                path: '/document-generation/generate',
                                element: <DocumentGenerationNewDocumentPage />,
                                handle: {
                                    title: 'Generate Document',
                                },
                            },
                        ],
                    },
                    {
                        id: 'dev-tools',
                        path: '/dev-tools',
                        children: [
                            {
                                id: 'coords-to-map',
                                path: '/dev-tools/coords-to-map',
                                element: <CoordinatesToMap />,
                                handle: {
                                    title: 'Coordinates to Map',
                                },
                            },
                        ],
                    },
                    {
                        id: 'tender',
                        path: '/tender',
                        handle: {
                            title: 'Tender',
                            type: PAGETYPE.MAIN,
                            icon: <TableChart />,
                        },
                        children: [
                            {
                                id: 'offer-evaluation-details',
                                path: '/tender/offer-evaluations/:tenderId',
                                element: <OfferEvaluationPage />,
                            },
                            {
                                id: 'offer-evaluation-create',
                                path: '/tender/offer-evaluations/create',
                                element: <OfferEvaluationPage />,
                                handle: {
                                    title: 'Create Offer Evaluation',
                                },
                            },
                            {
                                id: 'offer-evaluation-list',
                                path: '/tender/offer-evaluations',
                                element: <OfferEvaluationsListPage />,
                                handle: {
                                    title: 'Offer Evaluations List',
                                },
                            },
                            {
                                id: 'offer-processing-list',
                                path: '/tender/offer-processing',
                                element: <OffersListPage />,
                                handle: {
                                    title: 'Offers Processing',
                                },
                            },
                        ],
                    },
                    {
                        id: 'pv-sol-vm',
                        path: '/pv-sol-vm',
                        element: <PvSolVmPage />,
                        handle: {
                            title: 'PV*SOL VM',
                            type: PAGETYPE.MAIN,
                            icon: <SettingsSystemDaydreamIcon />,
                        },
                    },
                    {
                        id: 'real-estate-assets',
                        path: '/real-estate-asset-management',
                        handle: {
                            title: 'Real Estate Assets',
                            type: PAGETYPE.MAIN,
                            icon: <LocationCity />,
                        },
                        children: [
                            {
                                id: 'real-estate-asset-management',
                                path: '/real-estate-asset-management',
                                element: <RealEstateAssetManagementPage />,
                                handle: {
                                    title: 'Management',
                                },
                            },
                            {
                                // No `handle` — the Sidebar lists every child route that has
                                // one, and this parameterized detail route must not appear as
                                // a left-menu entry (its stripped-params link would be dead).
                                id: 'rea-steckbrief-variant-new',
                                path: '/real-estate-asset-management/:reaId/steckbriefe/:steckbriefId/variants/new',
                                element: <SteckbriefVariantFormPage />,
                            },
                            {
                                // Open an existing Variant in the same form page (GEN-765):
                                // prefilled from its data stamp; saving creates a NEW Variant.
                                // The static `new` sibling segment outranks this param in
                                // route ranking (pinned by SteckbriefVariantFormPage.test.tsx).
                                id: 'rea-steckbrief-variant-open',
                                path: '/real-estate-asset-management/:reaId/steckbriefe/:steckbriefId/variants/:variantId',
                                element: <SteckbriefVariantFormPage />,
                            },
                            {
                                id: 'rea-collection-view',
                                path: '/real-estate-asset-management/list-view',
                                element: <ReaCollectionViewPage />,
                                handle: {
                                    title: 'List View',
                                },
                            },
                            {
                                id: 'product-requirements-config',
                                path: '/real-estate-asset-management/product-requirements',
                                element: <ProductRequirementsConfigPage />,
                                handle: {
                                    title: 'Requirements',
                                },
                            },
                        ],
                    },
                ],
            },

            // footer
            // {
            //     id: "settings", path: "/settings/:settingsSubPage?", element: <SettingsPage />,
            //     handle: {
            //         defaultPath: "/settings/account",
            //         title: "Settings",
            //         type: PAGETYPE.FOOTER,
            //         icon: <SettingsRoundedIcon />,
            //     },
            // },
            // {
            //     id: "support", path: "/support", element: <SupportPage />,
            //     handle: {
            //         title: "Support",
            //         type: PAGETYPE.FOOTER,
            //         icon: <SupportRoundedIcon />,   // <QuestionAnswerRoundedIcon />
            //     },
            // },
        ],
    },

    {
        element: <EmptyLayout />,
        children: [
            {
                id: '404',
                path: '*',
                element: <NotFoundPage />,
                handle: {
                    title: '404 - Page not found',
                },
            },
        ],
    },
];
